import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";

const rootElement = document.getElementById("react-pagination-root");
document.addEventListener("DOMContentLoaded", (e) => {
  if (!rootElement) {
    return;
  }

  const root = createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
